import store from "@/store";

export const triggerError = (error) => {
  let err = error;
  if (error.response) {
    err = error.response.data.message;
  }
  if (!err) {
    err = "Unable to process";
  }
  store.dispatch("notification/triggerError", { detail: err });

  return false;
}
